export const catalogTypeIconLookupTable: { [key: string | 'unknown']: string } = {
  PurchasingGroup: 'home_work',
  Manufacturer: 'precision_manufacturing',
  Hybrid: 'join_right',
  Dealer: 'storefront',

  Unknown: 'question_mark',
};
